import { useContext } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter, Typography, Link, Grid } from '@mui/material';
import { dashboardContext } from './DashboardContext';
import { Link as RouterLink } from 'react-router-dom';
import Content from './Content';

let OrdersSyncDashboard = () => {

    let { ordersSync } = useContext(dashboardContext);

    return (
        <Content title='Orders sync with errors'>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Order</TableCell>
                        <TableCell>Description</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {ordersSync.map((order, index) =>
                        <TableRow hover key={index} sx={{ height: 60, maxHeigh: 60 }}>
                            <TableCell>
                                <Link component={RouterLink} to={`/order/${order.id}`}>{order.orderId}</Link>
                            </TableCell>
                            <TableCell>
                                {order.errors.map((err, idx) => <Typography key={idx}>{err}</Typography>)}
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                {ordersSync.length === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={2}>
                                <Typography variant="subtitle2">No orders found</Typography>
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
        </Content>
    )
}

export default OrdersSyncDashboard;